import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import zh_CN_header from './locales/zh_CN/header';
import zh_CN_footer from './locales/zh_CN/footer';
import zh_CN_popout from './locales/zh_CN/popout';

import zh_CN_home from './locales/zh_CN/home';
import zh_CN_course from './locales/zh_CN/course';
import zh_CN_teacher from './locales/zh_CN/teacher';
import zh_CN_publicClass from './locales/zh_CN/publicClass';
import zh_CN_howToTeach from './locales/zh_CN/howToTeach';
import zh_CN_levelTest from './locales/zh_CN/levelTest';
import zh_CN_join from './locales/zh_CN//join';
import zh_CN_about from './locales/zh_CN//about'

import en_US_header from './locales/en-US/header';

// the translations
// (tip move them in a JSON file and import them)

const resources = {
    'zh-CN': {
        header: {
            ...zh_CN_header
        },
        footer: {
            ...zh_CN_footer
        },
        popout: {
            ...zh_CN_popout
        },
        home: {
            ...zh_CN_home
        },
        course: {
            ...zh_CN_course
        },
        teacher: {
            ...zh_CN_teacher
        },
        publicClass: {
            ...zh_CN_publicClass
        },
        howToTeach: {
            ...zh_CN_howToTeach
        },
        levelTest: {
            ...zh_CN_levelTest
        },
        join: {
            ...zh_CN_join
        },
        about: {
            ...zh_CN_about
        }
    },
    'en-US': {
        header: {
            ...en_US_header
        }
    }
};

let storage = window.localStorage;

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: storage.language || 'zh-CN',

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;